import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "c-autocomplete" }
const _hoisted_2 = ["invalid", "placeholder"]
const _hoisted_3 = {
  key: 0,
  level: "info",
  "display-icon": "",
  accent: ""
}
const _hoisted_4 = { class: "header-warning" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("joy-input", {
        ref: "inputLocation",
        invalid: !_ctx.isValid,
        autocomplete: "off",
        icon: "location",
        placeholder: _ctx.$msg('profile.creation.completion.wizard.details.location.placeholder'),
        onFocusCapture: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.emitFocus && _ctx.emitFocus(...args)))
      }, null, 40, _hoisted_2)
    ]),
    (_ctx.isBlockedCountry && _ctx.address)
      ? (_openBlock(), _createElementBlock("joy-highlight", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$msg('profile.location.blocked.country.highlight.warning', _ctx.address.country)), 1),
          _createElementVNode("div", null, _toDisplayString(_ctx.$msg('profile.location.blocked.country.highlight.description.1', _ctx.address.country)) + " " + _toDisplayString(_ctx.$msg('profile.location.blocked.country.highlight.description.2')), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}